<template>
  <bimPopup title="" :value="value" @input="$emit('input', false)" width="90vw" closeOnWrapper>
    <div class="plugin-video pt-6">
      <vue-plyr v-metric="'LENDING-SMPP_CLICK-ON-VIDEO'">
        <div data-plyr-provider="youtube" data-plyr-embed-id="Z8iWKMLAYGs"></div>
      </vue-plyr>
    </div>
  </bimPopup>
</template>

<script>
import bimPopup from "@bimlib/components/bimPopup"
export default {
  name: "PopupVideo",
  components: {
    bimPopup,
  },
  props: {
    value: Boolean,
  }
}
</script>

<style scoped>
.plugin-video {
  width: 679px;
  max-width: 100%;
}
</style>
